
export const convertMongoDateToInputDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Tháng từ 1 đến 12
    const day = String(date.getDate()).padStart(2, '0'); // Ngày từ 1 đến 31
    return `${year}-${month}-${day}`;
}
